import { FormattedMessage, useIntl } from "react-intl";

import styles from "../styles.module.css";
import { Integration } from "../../../interfaces";
import {
  IonHeader,
  IonToolbar,
  IonContent,
  IonTitle,
  IonModal,
  IonButtons,
  IonButton,
} from "@ionic/react";

interface Properties {
  isOpen: boolean;
  onWillDismiss: () => void;
  create: Function;
  loading: boolean;
  error: string;
  isMobile: boolean;
  provider: string;
  integration: Integration | undefined;
}

const NewCodeIntegration = ({
  isOpen,
  onWillDismiss,
  create,
  loading,
  error,
  isMobile,
  provider,
  integration,
}: Properties) => {
  if (!provider) return null;
  const intl = useIntl();
  return (
    <IonModal isOpen={isOpen} onWillDismiss={onWillDismiss}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            <IonTitle>
              {isMobile ? (
                <FormattedMessage id={`integrations.${provider}Name`} />
              ) : (
                <div className={styles.titleDisplay}>
                  <div className={`${styles.titleItem} ${styles.logo}`}>
                    <div
                      className={`${styles.logo} ${integration?.cssLogo}`}
                    ></div>
                  </div>

                  <h3 className="fs-3">
                    <FormattedMessage id={`integrations.${provider}Name`} />
                  </h3>
                </div>
              )}
            </IonTitle>
          </IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => onWillDismiss()}>
              <FormattedMessage id="common.cancel" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className={styles.modalContent}>
          <h3 className="fs-3">
            <FormattedMessage
              id="integrations.acceptNewIntegration"
              values={{
                provider: intl.formatMessage({
                  id: `integrations.${provider}Name`,
                }),
              }}
            />
          </h3>

          <button
            className="btn btn-visito-primary btn-sm"
            color="success"
            onClick={() => create()}
            disabled={loading}
          >
            {loading ? (
              <>
                <FormattedMessage id="common.loading" />
                {`...`}
              </>
            ) : (
              <FormattedMessage id="common.accept" />
            )}
          </button>
          {error && (
            <div className="color-danger fw-semibold-1 fs-2 mt-2">{error}</div>
          )}
        </div>
      </IonContent>
    </IonModal>
  );
};

export default NewCodeIntegration;
